import { createSlice } from "@reduxjs/toolkit";
import { StarFeed, Meta } from "src/store/types";
import {
  doFetchStarFeedList,
  doCreateStarFeed,
  doUpdateStarFeed,
  doDeleteStarFeed,
  doReorderStarFeed,
} from "./star-feed.action";

interface StarFeedState {
  starFeeds: StarFeed[];
  meta: Meta | null;
  loading: boolean;
  createLoading: boolean;
  updateLoading: boolean;
  reorderLoading: boolean;
  error: string | null;
  searchQuery: string;
}

const initialState: StarFeedState = {
  starFeeds: [],
  meta: null,
  loading: false,
  createLoading: false,
  updateLoading: false,
  reorderLoading: false,
  error: null,
  searchQuery: "",
};

export const starFeedSlice = createSlice({
  name: "starFeed",
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    clearSearch: (state) => {
      state.searchQuery = "";
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doFetchStarFeedList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchStarFeedList.fulfilled, (state, action) => {
        state.loading = false;
        state.starFeeds = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchStarFeedList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doCreateStarFeed.pending, (state) => {
        state.createLoading = true;
        state.error = null;
      })
      .addCase(doCreateStarFeed.fulfilled, (state, action) => {
        state.createLoading = false;
        if (action.payload.data) {
          state.starFeeds.unshift(action.payload.data);
        }
      })
      .addCase(doCreateStarFeed.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doUpdateStarFeed.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(doUpdateStarFeed.fulfilled, (state, action) => {
        state.updateLoading = false;
        if (action.payload.data) {
          const updatedStarFeed = action.payload.data;
          state.starFeeds = state.starFeeds.map((item) =>
            item.sfId === updatedStarFeed.sfId ? updatedStarFeed : item,
          );
        }
      })
      .addCase(doUpdateStarFeed.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doDeleteStarFeed.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doDeleteStarFeed.fulfilled, (state, action) => {
        state.loading = false;
        const deletedSfId = action.payload.sfId;
        state.starFeeds = state.starFeeds.filter(
          (item) => item.sfId !== deletedSfId,
        );
      })
      .addCase(doDeleteStarFeed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doReorderStarFeed.pending, (state) => {
        state.reorderLoading = true;
        state.error = null;
      })
      .addCase(doReorderStarFeed.fulfilled, (state) => {
        state.reorderLoading = false;
      })
      .addCase(doReorderStarFeed.rejected, (state, action) => {
        state.reorderLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSearchQuery, clearSearch, clearError } =
  starFeedSlice.actions;

export default starFeedSlice.reducer;
